import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { MapSearchService } from "./map-search.service";
import { SessionStorageService } from "../../../../shared/services/storage/session-storage.service";
import { BehaviorSubject } from "rxjs";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApiLookupConstants } from "../../../../shared/constants/api-constants/api-lookup.constants";
import { FeatureSearchConstants } from "../../feature-search.constants";
import { HttpClient } from "@angular/common/http";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { Router } from "@angular/router";
import { CreateApplicationRoutingConstants } from "../../../../application/create-application/create-application-routing.constants";
import { ApiSearchConstants } from "./api-search.constants";
import GeometryUtils from "../../../../shared/utils/geometry-utils";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
let FeatureSearchService = class FeatureSearchService extends MapSearchService {
    sessionStorageService;
    http;
    router;
    zoningLookupList = new BehaviorSubject(null);
    zoningLookupListAsObservable = this.zoningLookupList.asObservable();
    constructor(sessionStorageService, http, router) {
        super(sessionStorageService);
        this.sessionStorageService = sessionStorageService;
        this.http = http;
        this.router = router;
        this.mapLocationAsObservable = this.mapLocation.asObservable();
    }
    setURL(url) {
    }
    getStartApplicationRoute() {
        const route = AppRoutingConstants.createRouteToView(this.getSelectedSystemModule() + "", CreateApplicationRoutingConstants.CREATE_APPLICATION_ROUTE, CreateApplicationRoutingConstants.DETAILS_ROUTE);
        const emptySpaceRe = new RegExp(" ", "gi");
        return route.replace(emptySpaceRe, "");
    }
    getPropertyZoning(moduleId) {
        // @ts-ignore
        const params = {
            $filter: `moduleId eq ${moduleId} and name eq '${FeatureSearchConstants.ZONING_LOOKUP}'`
        };
        return this.http.get(ApiLookupConstants.URL, { params });
    }
    // build links for map locator and create application request
    addMapLocatorLinks(propertiesFound, url, canCreate) {
        propertiesFound.forEach((property) => {
            property.link = this.setMapLink(property);
            if (canCreate) {
                property.link2 = this.setCreateApplicationLink(property, url);
            }
        });
    }
    setMapLink(property) {
        return {
            text: SharedConstants.VIEW_ON_MAP_TEXT,
            address: "",
            clickAction: (link) => {
                this.changeMapLocation(String(property.id));
            }
        };
    }
    setCreateApplicationLink(property, url) {
        return {
            text: SharedConstants.CREATE_APPLICATION_TEXT,
            address: "",
            clickAction: (link) => {
                this.startApplicationSelectedProperty(property, url);
            }
        };
    }
    transformAttributeKey(key) {
        switch (key.toLocaleLowerCase()) {
            case "objectid":
                return "id";
            case "erfno":
                return "erfNumber";
            case "address":
                return "address";
            case "allotment":
                return "allotment";
            case "propertydescription":
                return "propertyDescription";
            case "sgcode":
                return "sgCode";
            case "farmno":
                return "farmNumber";
            case "ptnnum":
                return "ptnNum";
            case "zoningcategory":
                return "zoning";
            case "totalvalue":
                return "totalValue";
            case "buildinguse":
                return "buildingUse";
            case "erfsize":
                return "erfSize";
            case "buildingfloorarea":
                return "buildingFloorArea";
            case "titledeed":
                return "titleDeed";
            default:
                return key.toLocaleLowerCase();
        }
    }
    startApplicationSelectedProperty(property, url) {
        // @ts-ignore
        this.doSearch(url, property.id.toString(), "objectId", true, true).then((result) => {
            if (result.length > 0) {
                let data = {};
                data.shape = WktConverterUtils.ConvertArcGISJsonToWkt(result[0].geometry);
                data.geometry = result[0].geometry ? GeometryUtils.mapGeometryToDTO(result[0].geometry) : null;
                data.zonings = result[0].attributes.ZoningCategory ? result[0].attributes.ZoningCategory : (result[0].attributes.zoningcategory ? result[0].attributes.zoningcategory : []);
                data.owners = [];
                data.buildings = [];
                for (const key in result[0].attributes) {
                    if (Object.prototype.hasOwnProperty.call(result[0].attributes, key)) { // Important for inherited properties
                        const value = result[0].attributes[key];
                        const newKey = this.transformAttributeKey(key); // Type assertion for safety
                        data[newKey] = value;
                    }
                }
                this.router.navigate([this.getStartApplicationRoute()], { state: { propertyData: JSON.stringify(data) } });
            }
        });
    }
    doPropertySearch(params) {
        return this.http.post(`${ApiSearchConstants.URL}/${ApiSearchConstants.FUNCTION_SEARCH}`, params);
    }
    getSelectedSearchLayerFields(params) {
        return this.http.post(`${ApiSearchConstants.URL}/${ApiSearchConstants.FUNCTION_GET_SEARCH_LAYER_FIELDS}`, params);
    }
    static ctorParameters = () => [
        { type: SessionStorageService },
        { type: HttpClient },
        { type: Router }
    ];
};
FeatureSearchService = __decorate([
    Injectable({
        providedIn: "root"
    })
], FeatureSearchService);
export { FeatureSearchService };
